import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export const BlueprintFeatureCard = () => (
  <Link to="/resources/digital-products/founder-blueprint-builder" className="group mt-12 grid lg:grid-cols-12 gap-8 bg-matte text-ivory rounded-2xl p-8 lg:p-12 luxury-shadow" data-testid="digital-product-card-founder-blueprint-builder">
    <div className="lg:col-span-8">
      <div className="text-[10px] font-label tracking-widest uppercase text-gold">Interactive · Powered by ORIGENNE&trade;, the digital headquarters of Toia Wallace</div>
      <h3 className="mt-4 font-serif-display text-3xl md:text-5xl tracking-tighter leading-tight">ORIGENNE Founder Blueprint Builder&trade;</h3>
      <p className="mt-4 text-ivory/65 leading-relaxed text-[15px] max-w-2xl">Six guided stages, personal financial planning, founder decision exercises, a 30-Day Launch Studio and a downloadable blueprint PDF, all in your private workspace.</p>
    </div>
    <div className="lg:col-span-4 flex lg:flex-col lg:items-end justify-between gap-6">
      <ArrowUpRight size={22} strokeWidth={1.2} className="text-ivory/50 group-hover:text-gold transition-colors duration-500" />
      <div className="font-label text-xs tracking-widest uppercase" data-testid="digital-product-price-founder-blueprint-builder">$39 · One-time</div>
    </div>
  </Link>
);
